type PageLoadingStateProps = {
  label: string;
  className?: string;
};

/**
 * Shared route-level loading feedback. The moving signal is intentionally
 * compact: it communicates work without replacing the current screen with a
 * distracting spinner or an empty expanse of copy.
 */
export function PageLoadingState({ label, className = '' }: PageLoadingStateProps) {
  return (
    <div className={`page-loading-state ${className}`.trim()} role="status" aria-live="polite">
      <span className="page-loading-signal" aria-hidden="true">
        <span />
      </span>
      <span>{label}</span>
    </div>
  );
}
